import { useCallback } from 'react';
const INVALID_RESPONSE_ERROR_PREFIX = 'invalid response from chat-service';
const NO_RESPONSE = '<no-response>';
export const useParseMessageResponse = () => useCallback(data => {
  var _assistantMessage$fun;
  const {
    assistantMessages,
    functionCalls: regularFunctionCalls,
    logs,
    agentName,
    requestId
  } = data;
  const assistantMessage = assistantMessages == null ? void 0 : assistantMessages.at(0);
  const hasAssistantMessageFunctionCalls = !!(assistantMessage != null && (_assistantMessage$fun = assistantMessage.functionCalls) != null && _assistantMessage$fun.length);
  const functionCalls = hasAssistantMessageFunctionCalls ? assistantMessage == null ? void 0 : assistantMessage.functionCalls : regularFunctionCalls;
  if (functionCalls != null && functionCalls.length) {
    if ((functionCalls == null ? void 0 : functionCalls.length) > 1) {
      throw new Error(`${INVALID_RESPONSE_ERROR_PREFIX}: more than one functionCalls`);
    }
    const functionCall = functionCalls.at(0);
    if (!functionCall) {
      throw new Error(`${INVALID_RESPONSE_ERROR_PREFIX}: functionCall is ${functionCall}`);
    }
    return {
      functionCall,
      fromAgent: agentName ?? 'master',
      requestId,
      logs: logs ?? []
    };
  }
  if (assistantMessages != null && assistantMessages.length) {
    if ((assistantMessages == null ? void 0 : assistantMessages.length) > 1) {
      throw new Error(`${INVALID_RESPONSE_ERROR_PREFIX}: more than one assistantMessages`);
    }
    if (!assistantMessage) {
      throw new Error(`${INVALID_RESPONSE_ERROR_PREFIX}: assistantMessage is ${assistantMessage}`);
    }
    return {
      id: assistantMessage.id ?? '',
      createdDate: assistantMessage.createdDate ?? new Date(),
      content: (assistantMessage == null ? void 0 : assistantMessage.content) ?? NO_RESPONSE,
      fromAgent: agentName ?? 'master',
      requestId,
      logs: logs ?? []
    };
  }
  throw new Error(`${INVALID_RESPONSE_ERROR_PREFIX}: neither assistantMessages nor functionCalls`);
}, []);
//# sourceMappingURL=useParseMessageResponse.js.map